import {
  GET_PRIMEUR_HEADER,
  GET_PRIMEUR_LIVE,
  GET_PRIMEUR_RECAP,
  GET_PRIMEUR_PREPA
} from '../constants/primeur';

const DEFAULT_STATE = {
  recap: {},
  live: [],
  feed: [],
  kpis: [],
  client_wines: [],
  prepa: {}
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GET_PRIMEUR_HEADER:
      return { ...state, ...action.payload };
    case GET_PRIMEUR_RECAP:
      return { ...state, recap: action.payload };
    case GET_PRIMEUR_LIVE:
      return { ...state, live: action.payload };
    case GET_PRIMEUR_PREPA:
      return { ...state, prepa: action.payload };
    default:
      return state;
  }
};
